import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

export default function SearchIdle() {
  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noreferrer');
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderBottom: (theme) =>
          theme.palette.mode === 'dark'
            ? '1px solid #333333'
            : '1px solid #d4d4d4',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light' ? 'background.paper' : '#171717',
      }}
    >
      <CardContent
        sx={{
          paddingBottom: 0,
        }}
      >
        <Typography gutterBottom variant="body1" component="div">
          Your discovered papers will appear here
        </Typography>
        <List sx={{ width: '100%' }} component="nav">
          <ListItem disablePadding>
            <ListItemText
              primary={
                <Typography variant="body2" color="text.secondary">
                  Use semantic discovery to find published papers based on
                  selected text from your note.
                </Typography>
              }
            />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText
              primary={
                <Typography variant="body2" color="text.secondary">
                  Add lexical filters to constrain the discovery by keywords
                </Typography>
              }
            />
          </ListItem>
        </List>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() =>
            openInNewTab(process.env.REACT_APP_PLATFORM_DOCUMENTATION)
          }
        >
          Learn More
        </Button>
      </CardActions>
    </Card>
  );
}
